import { useEffect, useState } from "react";

const defaultServices = [
  "🍽️ Restaurants & Catering",
  "🛒 Grocery & Food Stores",
  "💆 Health, Beauty & Wellness",
  "💼 Finance, Tax & Legal",
  "🏡 Real Estate & Relocation",
];

export default function FrequentServices({ onServiceClick, filters, categories }) {
  const [mappedIds, setMappedIds] = useState([]);

  useEffect(() => {
    const ids = defaultServices
      .map(name => categories.find(c => c.name === name)?.id)
      .filter(Boolean);

    setMappedIds(ids);
  }, [categories]);

  return (
    <div className="frequent-tags">
      <span className="frequent-searches">Frequent Searches </span>

      {defaultServices.map((service, i) => {
        const categoryObj = categories.find(c => c.name === service);
        const categoryId = categoryObj?.id;

        const isActive = categoryId && filters.categories.includes(categoryId);

        return (
          <button
            key={i}
            className={isActive ? "tag-btn active" : "tag-btn"}
            onClick={() => onServiceClick(service)}
          >
            {service}
          </button>
        );
      })}
    </div>
  );
}
